import React, { useState, useEffect } from 'react';
import {
  ArrowRight,
  ChevronRight,
  MapPin,
  X,
  Battery,
  Lightbulb,
  Cpu,
  Palette,
  Settings,
  TrendingUp,
  Globe,
  Layers,
  Award,
  ShieldCheck,
  Zap,
  Activity,
  Box,
  CornerRightDown,
  Wind,
  Target,
  FlaskConical
} from 'lucide-react';
import './Home.css';

// Award Images
import award2017 from "../img/hm/award/2017.png";
import award2018 from "../img/hm/award/2018.png";
import award2019 from "../img/hm/award/2019.png";
import award2020 from "../img/hm/award/2020.png";
import award2021 from "../img/hm/award/2021.png";

// Certification Images
import isonew from "../img/hm/award-certifications/iso-new.png";
import fc from "../img/hm/award-certifications/fc.png";
import ce from "../img/hm/award-certifications/ce.png";
import msme from "../img/hm/award-certifications/msme.png";
import nsic from "../img/hm/award-certifications/nsic.png";
import trademark from "../img/hm/award-certifications/trademark.png";

// Factory Images
import mohalifactoryimg from "../img/hm/mohali-factory.png";
import rajpurafactory from "../img/hm/rajpura-factory.jpg";

import companycatalog from '../catalogues/Spinoff-Technopark-Ltd.pdf'

const Home = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const brands = [
    { name: "Finike Lithium", description: "Upcoming R&D/design-based manufacturing facility, being the first in Punjab for the manufacturing of lithium battery, ESS, and solar energy solutions.", icon: <Battery size={32} />, category: "Energy Solutions", vertical: "https://finikelithium.com/" },
    { name: "Finike Lights", description: "Punjab’s first manufacturing facility in the LED domain, with a state-of-the-art manufacturing setup to cater to different users across society such as architects, builders, homes, offices, industries, and project-based lighting solutions.", icon: <Lightbulb size={32} />, category: "Lighting Systems", vertical: "https://www.finikelights.com/" },
    { name: "Imperial LED", description: "Spinoff has its own manufacturing facility with it's own SMT line and R&D testing facility for various kinds of LED drivers and SMPS used for illumination, under its brand Imperial LED, for different user experiences in lighting (architects, industry, and others).", icon: <Cpu size={32} />, category: "LED Hardware", vertical: "https://imperial-led.com/" },

  ];

  const awards = [
    { year: "2017", img: award2017 },
    { year: "2018", img: award2018 },
    { year: "2019", img: award2019 },
    { year: "2020", img: award2020 },
    { year: "2021", img: award2021 },
  ];

  const certificates = [
    { name: "ISO", img: isonew },
    { name: "CE", img: ce },
    { name: "FC", img: fc },
    { name: "MSME", img: msme },
    { name: "NSIC", img: nsic },
    { name: "Trademark", img: trademark },
  ];

  const openLightbox = (img) => {
    setSelectedImage(img);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  return (
    <div className={`home-container ${isVisible ? 'is-ready' : ''}`}>
      {/* Lightbox Modal */}
      {selectedImage && (
        <div className="modal-overlay" onClick={closeLightbox}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={closeLightbox}><X /></button>
            <img src={selectedImage} alt="Enlarged view" />
          </div>
        </div>
      )}

      {/* 3D HERO SECTION */}
      <section className="hero">
        <div className="bg-blob" style={{ top: '-10%', left: '-10%' }} />
        <div className="bg-blob" style={{ top: '40%', right: '-10%', background: 'radial-gradient(circle, rgba(168, 85, 247, 0.08) 0%, transparent 70%)' }} />

        <div className="max-w hero-inner">
          <div className="hero-pill" style={{ marginTop: '60px' }}>
            <Globe size={14} style={{ marginRight: '8px' }} />
            Leading India's Industrial Evolution
          </div>
          <h1 className="hero-h1" style={{fontSize:'55px'}}>Building the future through <span>powerful brands.</span></h1>
          <p className="hero-p">
            Spinoff is a multi-sectoral titan, architecting high-performance ecosystems
            in green energy, intelligent lighting, and precision hardware.
          </p>
          <div className="hero-btns">
            <button className="btn-3d btn-3d-primary"><a href={companycatalog} target="_blank" rel="noopener noreferrer" style={{color:'white'}}>Explore Portfolio</a> <ArrowRight size={20} /></button>
            <button className="btn-3d btn-3d-outline"> <a href='/our-infrastructure' style={{color:'black'}}>Our Infrastructure</a></button>
          </div>

          <div className="stats" style={{ marginTop: '100px', borderTop: '1px solid rgba(0,0,0,0.05)', paddingTop: '60px' }}>
            <div className="stat-box"><h4>2014</h4><p>ESTABLISHED</p></div>
            <div className="stat-box"><h4>700+</h4><p>PRODUCT SKUs</p></div>
            <div className="stat-box"><h4>2</h4><p>MEGA HUBS</p></div>
            <div className="stat-box"><h4>500+</h4><p>CUSTOMERS</p></div>
          </div>
        </div>
      </section>

      {/* "WHO WE ARE" - THE FULL BENTO NARRATIVE */}
      <section className="who-we-are">
        <div className="max-w">
          <h2 className="who-title-main" style={{fontSize:'50px'}}>A Decadal Odyssey <span className="highlight-gradient">of Industrial Excellence.</span></h2>

          <div className="who-bento-grid">
            <div className="bento-card bento-card-main">
              <div className="bento-orb" />

              {/* NEW ADDED MISSION CONTENT TO FILL SPACE */}
              <div style={{ marginBottom: '48px', paddingBottom: '40px', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                <span className="bento-tag">Our Core Ethos</span>
                <h3 className="bento-h3" style={{ fontSize: '24px' }}>Precision Engineering & R&D Excellence.</h3>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginTop: '30px' }}>
                  <div style={{ padding: '16px' }}>
                    <Target size={20} color="#6366f1" style={{ marginBottom: '10px' }} />
                    <h4 style={{ fontSize: '12px', color: '#fff', marginBottom: '4px' }}>MISSION</h4>
                    <p style={{ fontSize: '11px', color: '#71717a' }}>Focus on clean tech energy with in house R&D and manufacturing of Lithium Batteries and ESS Solutions</p>
                  </div>
                  <div style={{ padding: '16px' }}>
                    <FlaskConical size={20} color="#a855f7" style={{ marginBottom: '10px' }} />
                    <h4 style={{ fontSize: '12px', color: '#fff', marginBottom: '4px' }}>R&D FOCUS</h4>
                    <p style={{ fontSize: '11px', color: '#71717a' }}>Exploring/Developing/Executing the new product development in clean tech energy space with consistent R&D efforts by qualified resources in power Electrical, machnical and  power electronics to Exhibited a strong R&D base in spinoff with upcoming technologies and product development in clean tech space.</p>
                  </div>
                </div>
              </div>

              <div className="bento-body">
                <span className="bento-tag">The Genesis - 2014</span>
                <h3 className="bento-h3" style={{ fontSize: '28px' }}>Punjab's 1st LED Pioneer.</h3>
                <p className="bento-p" style={{ fontSize: '15px' }}>
                  Throughout the initial journey of evolution in the Lighting industry when CFL started fading out and LED started emerging as a technologically advanced product, Spinoffs’ started the Punjabs’ 1st manufacturing operations of LED lights, in the Industrial Area of Mohali in 2014.
                  This facility is equipped with highly skilled R&D and NPD teams along with the most advanced Machines.
                </p>
                <div style={{ marginTop: '24px', color: '#6366f1', display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <Zap size={24} /> 
                  <div className="highlight-glass" style={{ padding: '6px 12px', fontSize: '10px', fontWeight: '900' }}>LEGACY OF INNOVATION</div>
                </div>
              </div>
            </div>

            <div className="bento-card bento-card-highlight">
              <span className="bento-tag">2016 - 2020: The Rapid Scale</span>
              <h3 className="bento-h3" style={{ fontSize: '28px' }}>Market Leadership.</h3>
              <p className="bento-p" style={{ fontSize: '15px' }}>
               Spinoff started its journey in the manufacturing of smart lighting solutions in LED architectural products and was able to reach many architects, builders, and contractors in local and nearby Chandigarh. Spinoff has launched two brands in lighting, which are Finike Lights and Imperial LED. From 2014 to 2022, it primarily remained engaged in different projects and lighting solutions connected with homes, offices, and industries, including industrial lights and pharma lights. Thereafter, from 2022, Spinoff diversified with a new factory in Rajpura, Punjab for forward and backward integration in lighting and also launched its R&D and NPD facilities for lithium batteries, ESS, servo, UPS, inverter, injection molding, tool room, sheet metal, and cabinet manufacturing facilities, all equipped with CNC machines with precision and accuracy for manufacturing products under its domain.
              </p>
              <div style={{ marginTop: '20px', color: '#a855f7' }}><Activity size={32} /></div>
            </div>


            <div className="bento-card" style={{ gridColumn: '1 / -1', background: 'linear-gradient(90deg, rgba(99, 102, 241, 0.1) 0%, transparent 100%)' }}>
              <div style={{ display: 'flex', gap: '40px', alignItems: 'center' }}>
                <div style={{ flex: 1 }}>
                  <span className="bento-tag">2024: The Green Energy Pivot</span>
                  <h3 className="bento-h3">Lithium Batteries and ESS manufacturing Facilities</h3>
                  <p className="bento-p" style={{ fontSize: '15px' }}>
                    Since early 2020, the use of lithium batteries has been growing across society in various applications such as EV, solar, and ESS. By understanding the potential business opportunities in this sector, Spinoff launched its backward and forward facilities in the lithium space to capture the rising opportunities in the clean tech energy domain. Today, Spinoff is the first in Punjab (North India) to have such a scale of facilities with forward and backward in-house manufacturing of various products connected to the lithium and ESS domain. This new factory in Rajpura is spread across 250,000 sq. ft. of campus, having all facilities under one roof.
                  </p>
                </div>
                <Battery size={80} style={{ opacity: 0.2, color: '#6366f1' }} />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 3D BRAND CARDS */}
      <section className="brands" style={{ padding: '100px 0', background: '#fafafa' }}>
        <div className="max-w">
          <div className="section-head" style={{ marginBottom: '60px', textAlign: 'center' }}>
            <p style={{ fontSize: '11px', fontWeight: '900', color: '#6366f1', marginBottom: '16px', letterSpacing: '0.2em' }}>DOMINANT VERTICALS</p>
            <h2 style={{ fontSize: '40px', fontWeight: '900', letterSpacing: '-1.5px' }}>Architecting <span className="highlight-gradient">Industry Standards.</span></h2>
          </div>
          <div className="brands-grid">
            {brands.map((brand, index) => (
              <div key={index} className="brand-card-3d">
                <div className="icon-box">{brand.icon}</div>
                <p style={{ fontSize: '10px', fontWeight: '900', color: '#6366f1', marginBottom: '12px', letterSpacing: '0.1em' }}>{brand.category}</p>
                <h3>{brand.name}</h3>
                <p>{brand.description}</p>
                <div style={{ marginTop: '32px', fontWeight: '800', fontSize: '11px', display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
                  <a href={brand.vertical} target="_blank" rel="noopener noreferrer">EXPLORE VERTICAL</a> <ArrowRight size={14} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* INFRASTRUCTURE */}
      <section className="factory-section" style={{ padding: '100px 0', background: '#fff' }}>
        <div className="max-w">
          <div className="section-head" style={{ marginBottom: '40px', textAlign: 'left' }}>
            <p style={{ fontSize: '11px', fontWeight: '800', color: '#6366f1', marginBottom: '10px' }}>INDUSTRIAL INFRASTRUCTURE</p>
            <h2 style={{ fontSize: '40px', fontWeight: '900' }}>Our Manufacturing <span className="highlight-gradient">Hubs.</span></h2>
          </div>
          <div className="factory-grid">
            <div className="factory-img-wrap" onClick={() => openLightbox(mohalifactoryimg)} style={{ borderRadius: '40px' }}>
              <img src={mohalifactoryimg} alt="Mohali Factory" style={{ height: '600px' }} />
              <div className="factory-badge">Mohali Manufacturing Center</div>
            </div>
            <div className="factory-img-wrap" onClick={() => openLightbox(rajpurafactory)} style={{ borderRadius: '40px' }}>
              <img src={rajpurafactory} alt="Rajpura Factory" style={{ height: '600px' }} />
              <div className="factory-badge">Rajpura Manufacturing Hub</div>
            </div>
          </div>
        </div>
      </section>

      {/* SEPARATE AWARDS SECTION */}
      <section className="award-section">
        <div className="max-w">
          <div className="section-head" style={{ marginBottom: '60px', textAlign: 'center' }}>
            <div style={{ display: 'inline-flex', padding: '12px', background: 'rgba(99,102,241,0.05)', borderRadius: '16px', color: '#6366f1', marginBottom: '20px' }}><Award size={32} /></div>
            <h2 style={{ fontSize: '40px', fontWeight: '900' }}>Legacy of <span className="highlight-gradient">Excellence.</span></h2>
            <p style={{ color: '#71717a', maxWidth: '600px', margin: '0 auto' }}>A decade of industry-shaping awards and institutional recognition.</p>
          </div>
          <div className="hall-grid">
            {awards.map((a, i) => (
              <div key={i} className="award-card-elite" onClick={() => openLightbox(a.img)}>
                <img src={a.img} alt="Award" />
                <span className="award-title-tag">{a.year} RECOGNITION</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SEPARATE CERTIFICATIONS SECTION */}
      <section className="cert-section">
        <div className="max-w">
          <div className="section-head" style={{ marginBottom: '60px', textAlign: 'center' }}>
            <div style={{ display: 'inline-flex', padding: '12px', background: 'rgba(99,102,241,0.05)', borderRadius: '16px', color: '#6366f1', marginBottom: '20px' }}><ShieldCheck size={32} /></div>
            <h2 style={{ fontSize: '40px', fontWeight: '900' }}>Compliance &  <span className="highlight-gradient">Certifications</span></h2>
            <p style={{ color: '#71717a', maxWidth: '600px', margin: '0 auto' }}>Built on trusted benchmarks to ensure quality, safety, and performance.</p>
          </div>
          <div className="hall-grid">
            {certificates.map((c, i) => (
              <div key={i} className="cert-card-elite" onClick={() => openLightbox(c.img)}>
                <img src={c.img} alt={c.name} />
                <span className="cert-name-label">{c.name}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="cta-footer" style={{ padding: '100px 0' }}>
        <div className="max-w">
          <div className="cta-box">
            <h2 style={{fontSize:'50px'}}>Scale your vision with <span className="highlight-gradient">Spinoff.</span></h2>
            <p>Connect with our engineering experts to start your next high-performance industrial project.</p>
            <button className="btn-3d btn-3d-primary" style={{ margin: '0 auto', background: '#fff', color: '#000' }}> <a href='/contact-us' target='_blank'>Build with us</a> <ArrowRight size={20} /></button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
